<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import { computed, ref, watch, nextTick } from 'vue';

defineOptions({ inheritAttrs: false });

const DURACAO_ENTRADA_MS = 280;

const props = defineProps({
    carregando: {
        type: Boolean,
        default: false
    },
    tamanho: {
        type: String,
        default: '50px'
    },
    espessura: {
        type: String,
        default: '8'
    },
    cor: {
        type: String,
        default: '#06090e'
    }
})

const passThrough = computed(() => ({
    root: { style: { width: `${props.tamanho} !important`, height: `${props.tamanho} !important` } },
    spinner: { strokeWidth: props.espessura, class: 'text-primary' },
    circle: { style: { stroke: `${props.cor} !important` } }
}));

const inicioConteudo = ref(null);
const fimConteudo = ref(null);
const exibirConteudo = ref(!props.carregando);

// Ao voltar a carregar, o conteúdo sai na hora para o carregador aparecer
watch(() => props.carregando, (carregando) => {
    if (carregando) exibirConteudo.value = false;
});

// O conteúdo só entra depois que o carregador termina de sumir, para os dois não se sobreporem
const aoSumirCarregador = async () => {
    if (props.carregando) return;

    exibirConteudo.value = true;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    await nextTick();

    // Anima cada elemento do slot sem envolvê-los, para não mexer no layout do pai
    for (let elemento = inicioConteudo.value?.nextElementSibling; elemento && elemento !== fimConteudo.value; elemento = elemento.nextElementSibling) {
        elemento.animate(
            [{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }],
            { duration: DURACAO_ENTRADA_MS, easing: 'cubic-bezier(0.2, 0, 0, 1)' }
        );
    }
};
</script>

<template>
    <Transition name="carregador" appear @after-leave="aoSumirCarregador">
        <div v-if="props.carregando" v-bind="$attrs">
            <ProgressSpinner :pt="passThrough" />
        </div>
    </Transition>

    <template v-if="exibirConteudo">
        <span ref="inicioConteudo" hidden />
        <slot />
        <span ref="fimConteudo" hidden />
    </template>
</template>

<style scoped>
.carregador-enter-active {
    transition: opacity 220ms ease-out, transform 220ms cubic-bezier(0.2, 0, 0, 1);
}

.carregador-leave-active {
    transition: opacity 180ms ease-in, transform 180ms ease-in;
}

.carregador-enter-from,
.carregador-leave-to {
    opacity: 0;
    transform: scale(0.85);
}

@media (prefers-reduced-motion: reduce) {
    .carregador-enter-active,
    .carregador-leave-active {
        transition: none;
    }
}
</style>
